/*
 * File: TeamSelected.tsx
 * Project: a-a
 * File Created: Wednesday, 15th January 2025 8:58:14 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 1st May 2026 5:09:35 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Link, useParams } from 'react-router-dom';

import { Chip, Divider, Drawer, Skeleton, useTheme } from '@mui/material';
import { ClientService } from '../../../service/client.service';
import { DashboardService } from '../../../service/dashboard.service';
import OverviewTab from '../../shared/CustomDashboard/Overview/OverviewTab';
import ActivityColumn from '../../shared/CustomDashboard/Overview/Activity/ActivityColumn';
import TaskColumn from '../../shared/CustomDashboard/Overview/Tasks/TaskColumn';
import SocialEngagement from '../../shared/CustomDashboard/Overview/SocialEngagement';
import KeyDeals from '../../shared/CustomDashboard/Overview/KeyDeals';
import ActivityTab from '../../shared/CustomDashboard/ActivityTab/ActivityTab';
import TaskTab from '../../shared/CustomDashboard/TaskTab/TaskTab';
import KeyDealsTab from '../../shared/CustomDashboard/KeyDealsTab/KeyDealsTab';
import ContactTab from '../../shared/CustomDashboard/ContactsTab/ContactTab';
import CustomHomepage from '../../shared/CustomHomePage/CustomHomepage';
import zeplinColor from '../../../theme/Color';
import CustomButton from '../../shared/CustomButton/CustomButton';
import DashboardDealCard from '../../shared/CustomDashboard/Overview/DashboardDealCard';
import { Constants } from '../../../utilities/constants';
import CustomCard from '../../shared/CustomCard/CustomCard';
import CustomDrawer from '../../shared/CustomDrawer/CustomDrawer';
import TeamDetailsTab from './TeamDetailsTab';
import TeamAssignmentsTab from './TeamAssignmentsTab';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setCurrentTab, setSelectedMember } from '../../../store/slices/teamUiSlice';
import { TeamService } from '../../../service/team.service';
import styles from './TeamSelected.module.css';
const drawerWidth = 240;
type SportsProps = {
  link: '';
  title: '';
  source: '';
};

const TeamSelected = () => {
  const sf_redirect = sessionStorage.getItem('sf_redirect') || '';
  const dispatch = useAppDispatch();
  const selectedMember = useAppSelector((state) => state.teamUi.selectedMember) || {};
  const currentTab = useAppSelector((state) => state.teamUi.currentTab);
  const params = useParams();
  const theme = useTheme();
  const userName = sessionStorage.getItem('user-name') || '';
  const today = new Date();

  const formattedDate = today.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  // tab functionality
  const [value, setValue] = React.useState(0);
  const [alert, setAlert] = React.useState('');
  const [drawerState, setDrawerState] = React.useState(false);
  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    console.log(open);
    setDrawerState(open);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    dispatch(setCurrentTab(newValue));
    setValue(newValue);
  };

  const handleClose = () => {
    setAlert('');
  };
  // data from api
  const [data, setData] = React.useState<any>();
  // const [details, setDetails] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const [sportsData, setSportsData] = React.useState([]);
  console.log(selectedMember);
  const getDeal = async (id: string) => {
    try {
      const res = await ClientService.getClientDeal(id);
      // console.log(res);
      setData(res);
    } catch (err: any) {
      console.log(err, 'errdeal');
      setAlert(err?.message as string);
    }
  };

  React.useEffect(() => {
    getDeal(params.id || '');
    sf_redirect === 'Task' && setValue(1);
    if (!sf_redirect) {
      setValue(currentTab || 0);
    }
  }, []);
  const DashboardTabs = [
    {
      label: 'Profile Details',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <TeamDetailsTab />
        </Box>
      ),
    },

    {
      label: 'Task',
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <TaskTab />
        </Box>
      ),
    },
    {
      label: 'Assignments',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <TeamAssignmentsTab />
        </Box>
      ),
    },
  ];

  return (
    <>
      <CustomHomepage
        sportsData={[]}
        ProfileDetails={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flex: 1,
              // width: '100%',
            }}
          >
            <Box sx={{ display: 'flex', gap: '16px', flex: 1 }}>
              <Box
                sx={{
                  width: { xs: '80px', xl: '100px' },
                  height: { xs: '80px', xl: '100px' },
                  borderRadius: '14px',
                  //   border: '1px solid black',

                  backgroundColor: zeplinColor.Brand1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {/* <img
                width={'100px'}
                height={'100px'}
                src={'/assets/demo-client.svg'}
                alt='logo'
                style={{ objectFit: 'fill' }}
              /> */}
                <Typography variant='responsiveDisplay4' sx={{ color: zeplinColor.Neutral1 }}>
                  {selectedMember?.name
                    ?.split(' ')
                    .map((val: any, index: number) =>
                      index === 0 || index === selectedMember?.name?.split(' ').length - 1
                        ? val[0]
                        : '',
                    )}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  // gap: '16px',
                  justifyContent: 'space-between',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                  }}
                >
                  {' '}
                  <Typography
                    sx={{ fontSize: { xs: '24px', xl: '36px' }, fontWeight: '300' }}
                    color={zeplinColor.Neutral1}
                  >
                    {selectedMember?.name ?? 'N/A'}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <Chip
                      label={
                        <Typography
                          variant='responsiveLabel1'
                          color={zeplinColor.Neutral1}
                          sx={{ display: 'flex', alignItems: 'center' }}
                        >
                          {selectedMember?.position ?? 'N/A'}
                        </Typography>
                      }
                      sx={{
                        backgroundColor: zeplinColor.Neutral10,
                        padding: '5px 12px 5px 12px',
                        borderRadius: '50px',
                        // width: '47px',
                        height: '24px',
                        '&.MuiChip-root': {
                          // flex: 1,
                        },
                      }}
                    />

                    {selectedMember?.title && (
                      <Chip
                        label={
                          <Typography
                            variant='responsiveLabel1'
                            color={zeplinColor.Neutral1}
                            sx={{ display: 'flex', alignItems: 'center' }}
                          >
                            {selectedMember?.title ?? 'N/A'}
                          </Typography>
                        }
                        sx={{
                          backgroundColor: zeplinColor.Neutral10,
                          padding: '5px 12px 5px 12px',
                          borderRadius: '50px',
                          // width: '47px',
                          height: '24px',
                          '&.MuiChip-root': {
                            // flex: 1,
                          },
                        }}
                      />
                    )}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '32px',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    {' '}
                    <img
                      src='/assets/email.svg'
                      className={styles.icon}
                      style={{ objectFit: 'fill' }}
                    />
                    <a
                      href={`mailto:${selectedMember?.email}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      className={styles['contact-text']}
                      style={{ color: zeplinColor.Brand1, textDecoration: 'none' }}
                    >
                      {selectedMember?.email ?? 'N/A'}
                    </a>
                  </Box>
                  <Box
                    className={styles['contact-text']}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    {' '}
                    <img
                      src='/assets/mobile.svg'
                      className={styles.icon}
                      style={{ objectFit: 'fill' }}
                    />
                    {selectedMember?.mobile || selectedMember?.phone
                      ? selectedMember?.mobile || selectedMember?.phone
                      : 'N/A'}
                  </Box>
                </Box>
              </Box>
            </Box>
            <Link
              to={`https://${process.env.REACT_APP_SALESFORCE_URI}/${selectedMember?.id}`}
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: zeplinColor.Neutral1, textDecoration: 'none' }}
            >
              <CustomCard
                styles={{
                  borderRadius: '50px',
                  padding: '10px 10px 10px 16px',
                  backgroundColor: zeplinColor.BasicBlack,
                  border: `1px solid ${zeplinColor.Neutral6}`,
                  display: 'flex',
                  gap: '8px',
                  // flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                }}
              >
                <Typography variant='responsiveBody3'>Salesforce</Typography>
                <img src='/assets/arrow-white.svg' className={styles.linkIcon} />
              </CustomCard>
            </Link>
          </Box>
        }
        DealCard={<Box></Box>}
        DashboardTabs={DashboardTabs}
        handleChange={handleChange}
        value={value}
        alert={alert}
        handleClose={handleClose}
        Children={''}
      />
    </>
  );
};

export default TeamSelected;
